<template>
  <div class="collapse" :class="{ '-open': opened }" :aria-expanded="opened">
    <button class="collapse__heading" :aria-label="heading" @click="toggle()">{{ heading }}</button>
    <div class="collapse__content">
      <slot></slot>
    </div>
    <!-- .collapse__content -->
  </div>
  <!-- .collapse -->
</template>

<script>
export default {
  name: 'collapse',
  data() {
    return {
      opened: false,
    }
  },
  props: {
    heading: {
      type: String,
      default: () => '',
    },
    isOpen: {
      type: Boolean,
      default: () => false,
    },
  },
  components: {},
  mounted() {
    this.opened = this.isOpen
  },
  methods: {
    toggle() {
      this.opened = !this.opened
    },
  },
}
</script>
